import React from 'react';
import { PropTypes } from 'prop-types';
import Table from '../table/Table';
import { formatNumericDate } from '../../utils/dates';
import { renderTruncatedCell, useColumnMaxChars } from '../../utils/columnTruncation';

const VisitsTable = ({
  visits, onSort, isLoading,
}) => {
  const [purposeMeasureRef, purposeMaxChars] = useColumnMaxChars();

  if (isLoading || visits.length === 0) {
    return null;
  }

  const measuredVisitId = visits[0]?.id;

  const columns = [
    {
      title: 'Visit date',
      dataIndex: 'date',
      className: 'w-36',
      isSortable: true,
      render: (date) => formatNumericDate(date),
    },
    {
      title: 'Site',
      dataIndex: 'site_name',
      className: 'w-72',
      isSortable: true,
    },
    {
      title: 'Visit status',
      dataIndex: 'completed',
      className: 'w-44',
      isSortable: true,
      render: (completed) => (
        <span
          className={`${
            completed ? 'text-vamos-green1' : 'text-vamos-orange'
          }`}
        >
          {completed ? 'Completed' : 'Attempted'}
        </span>
      ),
    },
    {
      title: 'Purpose',
      dataIndex: 'purpose',
      className: 'w-64 max-w-64 truncate',
      isSortable: true,
      render: renderTruncatedCell({
        measureRef: purposeMeasureRef,
        maxChars: purposeMaxChars,
        measuredRowId: measuredVisitId,
      }),
    },
    {
      title: 'Leader',
      dataIndex: 'leader',
      className: 'w-44',
      isSortable: true,
    },
  ];

  return (
    <div className="flex justify-center w-full">
      <div className="w-full">
        <Table
          dataSource={visits}
          columns={columns}
          onSort={(values) => {
            onSort(values.field, values.order);
          }}
          typeOfData="visits"
        />
      </div>
    </div>
  );
};

VisitsTable.propTypes = {
  visits: PropTypes.array.isRequired,
  onSort: PropTypes.func.isRequired,
  isLoading: PropTypes.bool.isRequired,
};

export default VisitsTable;
